let dataVarId = "";
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const removeButton = event.target.closest('cart-drawer-remove-button, cart-remove-button');
      dataVarId = removeButton.getAttribute('data-var-id');
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0, "", dataVarId);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.drawer = document.getElementById('cart-drawer');

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    let drawer = document.querySelector('#cart-drawer');
    let specificElement = drawer.querySelector(`[data-index="${line}"]`);
    if (specificElement) {
      dataVarId = specificElement.getAttribute('data-var-id'); 
    } 
    const body = JSON.stringify({
      line,
      quantity,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let varId = 44494966194396;
        // getCart("",varId, dataVarId, 'remove', false);
        const parsedState = JSON.parse(state);

        this.updateExpressProduct(parsedState);
        getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      }).catch((error) => {
        console.error(error)
      });
  }

  updateExpressProduct(parsedState){
    if(parsedState.items_added.length > 0){
      let currentItemQuantity = 0;
      for(let item in parsedState.items){
        if(parseInt(parsedState.items[item].variant_id) == parsedState.items_added[0].variant_id && (parsedState.items[item].properties['Shipping'] === 'express' || parsedState.items[item].properties['Shipping'] === 'sample-express')){
          currentItemQuantity = parsedState.items[item].quantity;
        }
      }

      var counter = 1
      for(let item in parsedState.items){
        if(typeof parsedState.items[item].properties['data-attach-id'] !== "undefined"){
          if(parseInt(parsedState.items[item].properties['data-attach-id']) == parsedState.items_added[0].variant_id){
            this.updateQuantityCustom(counter, currentItemQuantity);
            // this.updateQuantityCustom(counter, parsedState.items[item].quantity + parsedState.items_added[0].quantity);
          }
        }
        counter++;
      }
    }
    else if(parsedState.items_removed.length > 0){
      let currentItemQuantity = 0;
      for(let item in parsedState.items){
        if(parseInt(parsedState.items[item].variant_id) == parsedState.items_removed[0].variant_id && (parsedState.items[item].properties['Shipping'] === 'express' || parsedState.items[item].properties['Shipping'] === 'sample-express') ){
          currentItemQuantity = parsedState.items[item].quantity;
        }
      }
      var counter = 1
      for(let item in parsedState.items){
        if(typeof parsedState.items[item].properties['data-attach-id'] !== "undefined"){
          if(parseInt(parsedState.items[item].properties['data-attach-id']) == parsedState.items_removed[0].variant_id){
            // this.updateQuantityCustom(counter, parsedState.items[item].quantity - parsedState.items_removed[0].quantity);
            this.updateQuantityCustom(counter, currentItemQuantity);
          }
        }
        counter++;
      }
    }
    else{
      // do else part
    }
  }

  updateQuantityCustom(line, quantity, name) {
    let data = {
      "line" : line,
      "quantity" : quantity
    }

    let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => {
        this.updateCartData()
    })
    .catch((error) => {
        console.error('Error:', error);
    })
  }

  updateCartData(){
    const xhr = new XMLHttpRequest();
    xhr.open('GET', window.location.href, true);
    xhr.responseType = 'document';
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        const responseData = xhr.response;
        const cartContent = responseData.querySelector('#cart-drawer__content');
        const currentCartContent = document.querySelector('#cart-drawer__content');

        if (cartContent && currentCartContent) {
          currentCartContent.innerHTML = cartContent.innerHTML;
        } else {
          console.error('Cart content elements not found');
        }
      } else {
        console.error('Error:', xhr.statusText);
      }
    };
    xhr.onerror = function() {
      console.error('Network Error');
    };
    xhr.send();

  }
}

customElements.define('cart-drawer', CartDrawer);
